module.exports = __webpack_public_path__ + "img/ts-bar-bg4.dd86b162.png";